import { Link } from 'react-router-dom';
import avatar from "../../../adminassets/img/avatars/1.png";
import rocket from "../../../adminassets/img/illustrations/rocket.png";
import { useEffect, useState } from 'react';
import { ToastContainer, toast } from "react-toastify";
import { fetchUsers, setPageLoading } from '../../../service/slice/AuthSlice';
import { useDispatch, useSelector } from 'react-redux';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import { selectMode } from '../../../service/slice/ThemeSlice';
import Lottie from "lottie-react";
import crown from "../../../studentassets/Lottie/Crown.json";
import Free from "../../../studentassets/Lottie/Free.json";
import Loading from '../../Loading';


export default function EditProfile() {

    const userDetails = useSelector((state) => state?.userSlice?.value)
    const [first_name, setFirstName] = useState(userDetails?.first_name);
    const [last_name, setLastName] = useState(userDetails?.last_name);
    const [email, setEmail] = useState(userDetails?.email);
    const [phone, setPhone] = useState(userDetails?.phone);
    const [editPopupShow, setEditPopupShow] = useState(false);
    const [board, setBoard] = useState([]);
    const [subscriptionHistory, setSubscriptionHistory] = useState();
    const [packages, setpackage] = useState([]);
    const [othersBoard, setOthersBoard] = useState({
        type: "",
        value: ""
    });
    const [languages, setLanguages] = useState([]);
    const [othersLanguages, setOthersLanguages] = useState([]);
    const [loading, setLoading] = useState(true);

    const dispatch = useDispatch();
    const usertoken = localStorage.getItem("authToken");
    const animatedComponents = makeAnimated();
    const theme = useSelector(selectMode);
    const freeSubscription = useSelector((state) => state?.userSlice?.freeSubscription)
    const unlimited = useSelector((state) => state?.userSlice?.unlimited);
    const themeColor = {
        color: theme === 'light' ? '#212529' : '#fff',
        background: theme === 'light' ? '#fff' : '#1c1c39',
        boxShadow: theme === 'light' ? '#fff' : 'rgb(186 189 217 / 20%)'
    };


    // User Edit Details Section
    const handleEdit = async (event) => {
        event.preventDefault();

        const post_data = {
            first_name: first_name,
            last_name: last_name,
            medium: JSON.stringify(othersLanguages.map((elem) => elem.value)),
            board: othersBoard.value
        };

        if (!first_name) {
            toast.info("Please enter first name!");
            return;
        }
        if (!last_name) {
            toast.info("Please enter last name!");
            return;
        }


        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/user/editProfile`, {
                method: 'POST',
                mode: 'cors',
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": `Bearer ${usertoken}`
                },
                body: JSON.stringify(post_data),
            });
            const data = await response.json();

            if (data.status === true) {
                toast.success("User profile update successfully!");
                setEditPopupShow(false);
            } else {
                toast.error("Failed to update user profile.");
            }

        } catch (error) {
            toast.error("Something went wrong! Please try again later.");
        }
    };

    // View Subscription Details Section
    const fetchAllSubscription = async () => {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/user/getUserSubscription`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${usertoken}`
            },
        });
        return response.json();
    };

    // Fetch All Study Profile
    const fetchStudyProfile = async () => {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/service/getStudyProfile`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${usertoken}`
            },
        });
        return response.json();
    };

    // Fetch All Language
    const fetchLang = async () => {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/service/getAllLanguage`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${usertoken}`
            },
        });
        return response.json();
    };

    function editUserDetails() {
        setEditPopupShow(true);
        dispatch(fetchUsers({ token: localStorage.getItem('authToken'), type: "user" }))
    }

    useEffect(() => {
        fetchAllSubscription().then((res) => {
            if (res.status) {
                setSubscriptionHistory(res.subscription);

                fetchStudyProfile().then((res) => {
                    if (res.status) {
                        setBoard(res?.studyProfile)
                        if (userDetails) {
                            const boards = res?.studyProfile.map((elem) => elem.board)
                            if (boards.includes(userDetails?.board)) {
                                setOthersBoard({ type: userDetails?.board, value: userDetails?.board });
                            } else {
                                setOthersBoard({ type: 'Others', value: userDetails?.board });
                            }
                        }

                        fetchLang().then((res) => {
                            if (res.status) {
                                setLanguages(res?.languages)
                                if (userDetails) {
                                    const languages = res?.languages.map((elem) => elem.language)
                                    const languageArr = [];
                                    JSON.parse(userDetails?.medium).forEach(element => {
                                        if (languages.includes(element)) {
                                            languageArr.push({ value: element, label: element })
                                        } else {
                                            languageArr.push({ value: element, label: 'Others Language' })
                                        }
                                    });
                                    setOthersLanguages(languageArr);
                                }
                                setLoading(false);

                            } else {
                                toast.error("Failed to load languages. Please try again.");
                            }
                        }).catch((error) => {
                            toast.error("Something went wrong! Please try again later.");
                        });

                    } else {
                        toast.error("Failed to load study profile. Please try again.");
                    }
                }).catch((error) => {
                    toast.error("Something went wrong! Please try again later.");
                });

            } else {
                toast.error("Unable to load user details. Please try again later.");
            }
        }).catch((error) => {
            toast.error("Failed to fetch users. Please check your connection and try again.");
        });





    }, []);


    return (
        <>
            {/* Toast container */}
            <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} />

            {loading ?
                <Loading />
                :
                <div className="container-xxl flex-grow-1 container-p-y">
                    <div className="row">
                        {/* Customer-detail Sidebar */}
                        <div className="col-xl-4 col-lg-5 col-md-5 order-1 order-md-0">
                            {/* Customer-detail Card */}
                            <div className="card mb-6" style={themeColor}>
                                <div className="card-body pt-12">
                                    <div className="customer-avatar-section">
                                        <div className="d-flex align-items-center flex-column">
                                            <img className="img-fluid rounded-3 mb-4" src={avatar} height="120" width="120" alt="User avatar" />
                                            <div className="customer-info text-center mb-6">
                                                <h5 className={`mb-0 ${theme ? "text-secondary" : ""}`}>{first_name + ' ' + last_name}</h5>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="info-container">
                                        <h5 className={`border-bottom text-capitalize pb-4 mt-6 mb-4 ${theme ? "text-secondary" : ""}`}>Details</h5>
                                        <ul className="list-unstyled mb-6">
                                            <li className="mb-2">
                                                <span className={`${theme ? "text-secondary" : ""} h5 me-1`}>Name:</span>
                                                <span>{first_name + ' ' + last_name}</span>
                                            </li>
                                            <li className="mb-2">
                                                <span className={`${theme ? "text-secondary" : ""} h6 me-1`}>Email:</span>
                                                <span>{email ? email : 'N/A'}</span>
                                            </li>
                                            <li className="mb-2">
                                                <span className={`${theme ? "text-secondary" : ""} h6 me-1`}>Contact:</span>
                                                {phone ? <span>+91 {phone}</span> : <span>N/A</span>}
                                            </li>
                                            <li className="mb-2">
                                                <span className={`${theme ? "text-secondary" : ""} h6 me-1`}>Status:</span>
                                                {userDetails?.status ? <span className="badge bg-label-success rounded-pill">Active</span> : <span className="badge bg-label-danger rounded-pill">Inactive</span>}
                                            </li>
                                        </ul>
                                        <div className="d-flex justify-content-center">
                                            <Link to="" onClick={() => { editUserDetails() }} className="btn btn-primary text-white w-100" data-bs-target="#editUser" data-bs-toggle="modal" style={{ background: "#666cff" }}>Edit Details</Link>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Customer detail Card*/}
                            {/* <div className="card bg-primary d-none">
                            <div className="card-body">
                                <div className="row justify-content-between mb-4 flex-column">
                                    <div
                                        className="col-md-12 col-lg-7 col-xl-12 col-xxl-7 text-center text-lg-start text-xl-center text-xxl-start order-1 order-lg-0 order-xl-1 order-xxl-0">
                                        <h5 className="card-title text-white text-nowrap mb-4">Upgrade to premium</h5>
                                        <p className="card-text text-white">
                                            Upgrade customer to premium membership to access pro features.
                                        </p>
                                    </div>
                                    <span className="col-md-12 col-lg-5 col-xl-12 col-xxl-5 text-center text-lg-end text-xl-center text-xxl-end mx-auto mx-md-0 mb-2">
                                        <img src={rocket} className="w-px-75 m-2" alt="3dRocket" />
                                    </span>
                                </div>
                                <button className="btn btn-white text-primary w-100 fw-medium shadow-sm" data-bs-target="#upgradePlanModal" data-bs-toggle="modal" style={{ background: "#FFFF" }}>
                                    Upgrade to premium
                                </button>
                            </div>
                        </div> */}

                        </div>


                        {/* Customer Content */}
                        <div className="col-xl-8 col-lg-7 col-md-7 order-0 order-md-1">
                            {/* <div className="nav-align-top d-none">
                                <ul className="nav nav-pills flex-column flex-md-row mb-6 row-gap-2 flex-wrap">
                                    <li className="nav-item">
                                        <Link className="nav-link active" to=""><i className="icon-base ri ri-group-line icon-sm me-2"></i>Overview</Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link className="nav-link" to=""><i className="icon-base ri ri-lock-2-line icon-sm me-2"></i>Security</Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link className="nav-link" to=""><i className="icon-base ri ri-map-pin-line icon-sm me-2"></i>Address & Billing</Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link className="nav-link" to=""><i className="icon-base ri ri-notification-4-line icon-sm me-2"></i>Notifications</Link>
                                    </li>
                                </ul>
                            </div> */}


                            {/* Customer cards */}
                            <div className="row text-nowrap">

                                <div className="col-md-6 mb-6">
                                    <div className="card h-100">
                                        <div className="card-body" style={themeColor}>
                                            <div className="card-icon mb-2">
                                                <div className="avatar d-none">
                                                    <div className="avatar-initial rounded bg-label-primary">
                                                        <i className="icon-base ri ri-money-dollar-circle-line icon-24px"></i>
                                                    </div>
                                                </div>
                                            </div>


                                            {/* <div className="card-info">
                                            <h5 className="card-title mb-2">Current Package</h5>
                                            <div className="d-flex align-items-baseline gap-1 justify-content-between">
                                                <h5 className="text-primary mb-0">&#8377;250/Monthly</h5>
                                                <p className="mb-0" style={{ color: "#2dd104ff" }}>Active</p>
                                            </div>
                                            <p className="mb-0 text-truncate">Account balance for next purchase</p>
                                        </div> */}

                                            <div className="container">

                                                {subscriptionHistory ?
                                                    <div className='me-4'>
                                                        <Lottie animationData={crown} />
                                                    </div>
                                                    :
                                                    <div className='d-flex justify-content-center align-items-center me-1'>
                                                        <Lottie animationData={Free} style={{ width: "100px" }} />
                                                    </div>
                                                }

                                                <div className="text-center h3" style={{ color: "#0cce1cff" }}>
                                                    {subscriptionHistory ? subscriptionHistory.name : "Free"}
                                                </div>

                                                <div className="d-flex align-items-center justify-content-center">
                                                    <h4 className={`${theme ? "text-secondary" : ""} mb-0 me-1`}>{subscriptionHistory ? subscriptionHistory.amount : "10"}</h4>
                                                    <span>/ {subscriptionHistory?.type === 2 ? "Yearly" : "Monthly"}</span>
                                                </div>

                                                {/* <div className="mt-5 text-center">
                                                <button className="btn btn-outline-primary rounded-pill">
                                                    Upgrade
                                                </button>
                                            </div> */}

                                                <button className="btn btn-white text-primary w-100 fw-medium shadow-sm mt-3">
                                                    Upgrade your package
                                                </button>
                                            </div>


                                        </div>
                                    </div>
                                </div>

                                {/* <div className="col-md-6 mb-6 d-none">
                                <div className="card">
                                    <div className="card-body">
                                        <div className="card-icon mb-2">
                                            <div className="avatar">
                                                <div className="avatar-initial rounded bg-label-success">
                                                    <i className="icon-base ri ri-gift-line icon-24px"></i>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="card-info">
                                            <h5 className="card-title mb-2">Loyalty Program</h5>
                                            <span className="badge bg-label-success mb-2 rounded-pill">Platinum member</span>
                                            <p className="mb-0">3000 points to next tier</p>
                                        </div>
                                    </div>
                                </div>
                            </div> */}


                                <div className='col-md-6 mb-6'>
                                    <div className="card bg-primary">
                                        <div className="card-body">
                                            <div className="row justify-content-between mb-4 flex-column align-items-center">
                                                <div
                                                    className="w-100 col-md-12 col-lg-7 col-xl-12 col-xxl-7 text-center text-lg-start text-xl-center text-xxl-start order-1 order-lg-0 order-xl-1 order-xxl-0">
                                                    <h4 className="card-title text-center text-white text-wrap mb-4">Upgrade your package</h4>
                                                </div>

                                                <span className="col-md-12 col-lg-5 col-xl-12 col-xxl-5 text-center text-lg-end text-xl-center text-xxl-end mx-auto mx-md-0 mb-2">
                                                    <img src={rocket} className="w-px-75 m-2" alt="3dRocket" />
                                                </span>
                                            </div>
                                            <Link className="btn btn-white text-primary w-100 fw-medium shadow-sm" to="/user/packagehistory" style={{ background: "#FFFF" }}>
                                                Upgrade your package
                                            </Link>
                                        </div>
                                    </div>
                                </div>



                                <div className="col-md-6 mb-6">
                                    <div className="card" style={themeColor}>
                                        <div className="card-body">
                                            <div className="card-info">
                                                <h5 className={`${theme ? "text-secondary" : ""} card-title mb-2`}>Total Request</h5>
                                            </div>

                                            <div className="d-flex align-items-center justify-content-center">
                                                {unlimited?
                                                <h4 className="mb-0 me-1 text-primary">
                                                    Unlimited
                                                </h4>
                                                :
                                                <>
                                                    <div className="d-flex align-items-center mt-0 ms-2">
                                                        <h4 className="mb-0 me-1 text-primary">
                                                            {subscriptionHistory ? subscriptionHistory.total_request : freeSubscription}
                                                        </h4>
                                                    </div>

                                                    <span className='ms-1'>Question Left Out of  {subscriptionHistory ? subscriptionHistory.request : process.env.REACT_APP_FREE_Request}</span>
                                                </>}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>

                        </div>

                    </div>

                    {/* Edit User Modal */}
                    {editPopupShow && <div className={editPopupShow ? "modal fade show d-block ms-6" : "modal fade"} id="editUser" tabIndex="-1" aria-hidden="true">
                        <div className="modal-dialog modal-lg modal-simple modal-edit-user">
                            <div className="modal-content">
                                <div className="modal-body p-0">
                                    <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={() => { setEditPopupShow(false) }}></button>
                                    <div className="text-center mb-6">
                                        <h4 className="mb-2">Edit User Information</h4>
                                        <p className="mb-6">Updating user details will receive a privacy audit.</p>
                                    </div>
                                    <form className="row g-5" onSubmit={(event) => { handleEdit(event) }}>
                                        <div className="col-12 col-md-6">
                                            <div className="form-floating form-floating-outline">
                                                <input type="text" className="form-control" value={first_name} onChange={(event) => { setFirstName(event.target.value) }} placeholder="First Name" />
                                                <label htmlFor="modalEditUserFirstName">First Name</label>
                                            </div>
                                        </div>
                                        <div className="col-12 col-md-6">
                                            <div className="form-floating form-floating-outline">
                                                <input type="text" className="form-control" value={last_name} onChange={(event) => { setLastName(event.target.value) }} placeholder="Last Name" />
                                                <label htmlFor="modalEditUserLastName">Last Name</label>
                                            </div>
                                        </div>

                                        <div className="col-12 col-md-12">
                                            <div className="input-wrapper mt-2">
                                                <select value={othersBoard.value}
                                                    onChange={(event) => { setOthersBoard({ value: event.target.value == "Others" ? "" : event.target.value, type: event.target.value }) }}
                                                    required>
                                                    <option value="">Select Board</option>
                                                    {board.map((study, idx) => {
                                                        return <option key={idx} value={study.board}>{study.board}</option>
                                                    })
                                                    }
                                                    <option value="Others">Select Others Board</option>
                                                </select>
                                            </div>
                                        </div>

                                        {othersBoard.type == "Others" && (
                                            <div className="col-12 col-md-12">
                                                <div className="input-wrapper mt-2">
                                                    <input type="text" value={othersBoard.value}
                                                        onChange={(event) => { setOthersBoard({ ...othersBoard, value: event.target.value }); }}
                                                        placeholder="Enter Your Board Name" Style="border:none !important" required />
                                                </div>
                                            </div>
                                        )}



                                        { /* Language Section */}
                                        <>
                                            <Select
                                                className='mt-3'
                                                closeMenuOnSelect={false}
                                                components={animatedComponents}
                                                isMulti
                                                options={[...languages.map((lang, index) => ({ value: lang.language, label: lang.language })), { value: "Others Language", label: "Others Language" }]}
                                                onChange={(value) => { setOthersLanguages(value) }}
                                                placeholder={<div className='d-flex p-0' Style="width: 150px !important;">Select Medium</div>}
                                                // value={othersLanguages}
                                                defaultValue={othersLanguages}
                                            />

                                            {othersLanguages.filter((elem) => elem.label == "Others Language").length > 0 && (
                                                <div className="col-12 col-md-12">
                                                    <div className="input-wrapper mt-2">
                                                        <input type="text" placeholder="Enter Your Other Language" Style="border:none !important" onChange={(event) => { const data = structuredClone(othersLanguages); data.map((elem) => { if (elem.label == "Others Language") { elem.value = event.target.value }; return elem; }); setOthersLanguages(data) }} value={othersLanguages.filter((elem) => elem.label == "Others Language")[0].value} required />
                                                    </div>
                                                </div>
                                            )}
                                        </>


                                        { /* Subject Section */}
                                        {/* <Select
                                        className='mt-3'
                                        closeMenuOnSelect={false}
                                        components={animatedComponents}
                                        isMulti
                                        options={[...subject.map((sub, index) => ({ value: sub.subject, label: sub.subject })), { value: "Others Subject", label: "Others Subject" }]}
                                        onChange={(value) => { setOthersSubject(value) }}
                                        placeholder={<div className='d-flex p-0' Style="width: 150px !important;">Select Subject</div>}
                                        // value={othersSubject}
                                        defaultValue={othersSubject}
                                        value={othersSubject}
                                    />

                                    {othersSubject.filter((elem) => elem.label == "Others Subject").length > 0 && (
                                        <div className="col-12 col-md-12">
                                            <div className="input-wrapper mt-2">
                                                <input type="text" placeholder="Enter Your Other Subject" Style="border:none !important" onChange={(event) => { const data = structuredClone(othersSubject); data.map((elem) => { if (elem.label == "Others Subject") { elem.value = event.target.value; }; return elem; }); setOthersSubject(data); console.log(data) }} value={othersSubject.filter((elem) => elem.label == "Others Subject")[0].value} required />
                                            </div>
                                        </div>
                                    )} */}

                                        {/* <div className="col-12 col-md-6 d-none">
                                        <div className="form-floating form-floating-outline">
                                            <select className="form-select" aria-label="Default select example">
                                                <option value="1" selected>Active</option>
                                                <option value="2">Inactive</option>
                                                <option value="3">Suspended</option>
                                            </select>
                                            <label htmlFor="modalEditUserStatus">Status</label>
                                        </div>
                                    </div> */}


                                        <div className="col-12 text-center edit-profile">
                                            <button type="submit" className="btn btn-primary me-3 w-75 ms-3" style={{ background: "#666cff" }}>Submit</button>
                                            <button type="reset" className="btn btn-outline-secondary w-75 mt-4" onClick={() => { setEditPopupShow(false) }}>
                                                Cancel
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>}

                </div>
            }
        </>
    )
}
